"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = exports.fetchData = void 0;
const react_1 = require("react");
const apiUtils_1 = require("../util/apiUtils");
const auth_1 = require("../util/auth");
const auth0_react_1 = require("@auth0/auth0-react");
const fetchData = async (setResponse, fetchUrl, signal, getAuthHeader, getAccessTokenSilently, loginWithRedirect, body) => {
    if (fetchUrl) {
        setResponse({ status: apiUtils_1.LoaderStatus.Loading });
        try {
            const accessToken = await (0, auth_1.getAccessToken)(getAccessTokenSilently); // Fetch the token
            const authHeader = getAuthHeader(accessToken);
            const headersWithAuth = {
                "Content-Type": "application/json",
                ...authHeader,
            }; // Pass the token to getAuthHeader
            const result = await fetch((0, apiUtils_1.getAPIUrl)() + fetchUrl, {
                signal,
                method: body ? "POST" : "GET",
                body,
                headers: headersWithAuth,
            });
            if (!signal.aborted) {
                const data = await result.json();
                if (data.error) {
                    setResponse({ status: apiUtils_1.LoaderStatus.Error, error: data.error });
                }
                else {
                    setResponse({ status: apiUtils_1.LoaderStatus.Success, data });
                }
            }
        }
        catch (error) {
            if (signal.aborted) {
                console.log("Fetch aborted:", error);
            }
            else if ((0, auth_1.shouldTriggerLoginRedirect)(error)) {
                loginWithRedirect();
            }
            else {
                console.error(error);
                setResponse({ status: apiUtils_1.LoaderStatus.Error, error });
            }
        }
    }
};
exports.fetchData = fetchData;
const useFetch = (initialUrl, initialBody, waitForBody) => {
    const { getAuthHeader, getAccessTokenSilently } = (0, auth_1.useAuthentication)();
    const { loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    const reducer = (oldsState, newState) => {
        if (newState.status === apiUtils_1.LoaderStatus.Idle) {
            return { status: apiUtils_1.LoaderStatus.Idle };
        }
        else {
            return {
                ...oldsState,
                ...newState,
            };
        }
    };
    const [url, setUrl] = (0, react_1.useState)(initialUrl);
    const [postBody, setPostBody] = (0, react_1.useState)(initialBody);
    const [response, setResponse] = (0, react_1.useReducer)(reducer, {
        status: apiUtils_1.LoaderStatus.Idle,
    });
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;
        if (url && (postBody || !waitForBody)) {
            (0, exports.fetchData)(setResponse, url, signal, getAuthHeader, getAccessTokenSilently, loginWithRedirect, postBody ?? initialBody);
        }
        return () => {
            if (!signal.aborted) {
                abortController.abort(); // Abort only if the signal hasn't already been aborted
            }
        };
    }, [url, postBody]);
    const refresh = () => {
        const abortController = new AbortController();
        const signal = abortController.signal;
        if (url && (postBody || !waitForBody)) {
            (0, exports.fetchData)(setResponse, url, signal, getAuthHeader, getAccessTokenSilently, loginWithRedirect, postBody ?? initialBody);
        }
    };
    if (!initialUrl && !url) {
        return [{ status: apiUtils_1.LoaderStatus.Idle }, setUrl, setPostBody, refresh];
    }
    return [response, setUrl, setPostBody, refresh];
};
exports.useFetch = useFetch;
exports.default = exports.useFetch;
